import { ymdKey } from './dateFormat';

// The link modal's list is read against the list printed on the מרכזת, so it
// holds both kinds of row in one order: candidate notes, and references the
// invoice names that cannot be linked (no checkbox, nothing to
// sum), and credit notes shown for reference. Viewing helpers only: which notes are SELECTED lives in the modal, and
// nothing here may affect it, because the save is a full replacement.

// One real invoice checked 02/11/2026 prints oldest first, hence the default.
export const LINK_SORT_DEFAULT = { field: 'date', dir: 'asc' };
export const LINK_SORT_OPTIONS = [
  { key: 'date', label: 'תאריך' },
  { key: 'number', label: 'מספר תעודה' },
];

// Numbers compare as numbers ("9" before "10"), and a printed "15/020172" sorts
// by its digits. No digits at all: null, which the sort puts last.
export function noteNumberKey(docNum) {
  const digits = String(docNum ?? '').replace(/\D/g, '');
  return digits ? Number(digits) : null;
}

export const LINK_SORT_ACCESSORS = {
  date: (r) => ymdKey(r.date) || null,
  number: (r) => noteNumberKey(r.doc_num),
};

// Typing the digits finds a number printed with separators: 15020172 finds
// 15/020172, the same way the sort reads it.
export function matchesNoteSearch(docNum, query) {
  const q = String(query ?? '').trim().toLowerCase();
  if (!q) return true;
  const num = String(docNum ?? '').toLowerCase();
  if (num.includes(q)) return true;
  return /^\d+$/.test(q) && num.replace(/\D/g, '').includes(q);
}

// Stable, undated last. Fed in before useSortable, so its unsorted state (a third
// header click, ברירת מחדל on a phone) is this order and not the server's.
export function oldestFirst(rows) {
  const key = LINK_SORT_ACCESSORS.date;
  return [...rows].sort((a, b) => {
    const ka = key(a), kb = key(b);
    if (ka == null && kb == null) return 0;
    if (ka == null) return 1;
    if (kb == null) return -1;
    return ka < kb ? -1 : ka > kb ? 1 : 0;
  });
}

// `id` is namespaced so it can never collide with a document id, or be selected.
export const missingRow = (m) => ({
  id: `missing:${m.ref_num}`,
  isMissing: true,
  doc_num: m.ref_num,
  date: m.ref_date,
  source: m,
});

// A credit note shown for the admin to check: unselectable for now, in no sum, and
// its id namespaced for the same reason. Net, signed: it is money off.
export const creditRow = (c) => ({
  id: `credit:${c.id}`,
  isCredit: true,
  documentId: c.id,
  doc_num: c.doc_num,
  date: c.date,
  doc_type: c.doc_type,
  net: -Math.abs(Number(c.subtotal) || 0),
});

// The dates a list of DD/MM/YYYY rows spans, in the bounds isDateInRange takes; null
// with no dated row. When the window opens wide on an invoice that names its notes,
// this keeps years of a supplier's old credit notes off the screen.
export function dateSpan(dates) {
  const keys = dates.map(d => ymdKey(d)).filter(Boolean).sort();
  return keys.length ? { from: keys[0], to: keys[keys.length - 1] } : null;
}

// What a refused reference really is, for the red row. '' when it is simply absent.
export function blockerLabel(blocker) {
  if (blocker?.kind === 'other_type') return `קיימת כ${blocker.doc_type}`;
  if (blocker?.kind === 'linked_elsewhere') return blocker.invoice_doc_num ? `מקושרת לחשבונית ${blocker.invoice_doc_num}` : 'מקושרת לחשבונית אחרת';
  return '';
}

// Notes the invoice does not name go last: they are the ones least likely to
// belong, and mixed in they break the line-by-line reading. Stable, so each
// group keeps the chosen sort.
export function offInvoiceLast(rows, isOffInvoice) {
  return [...rows.filter(r => !isOffInvoice(r)), ...rows.filter(isOffInvoice)];
}
